import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardLayout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.4 7V17M5.61818 17H18.3818C19.2983 17 19.7565 17 20.1065 16.8443C20.4144 16.7073 20.6648 16.4888 20.8216 16.22C21 15.9144 21 15.5144 21 14.7143V9.28571C21 8.48564 21 8.0856 20.8216 7.78001C20.6648 7.51121 20.4144 7.29267 20.1065 7.1557C19.7565 7 19.2983 7 18.3818 7H5.61818C4.70173 7 4.24351 7 3.89347 7.1557C3.58557 7.29267 3.33524 7.51121 3.17835 7.78001C3 8.0856 3 8.48564 3 9.28571V14.7143C3 15.5144 3 15.9144 3.17835 16.22C3.33524 16.4888 3.58557 16.7073 3.89347 16.8443C4.24351 17 4.70173 17 5.61818 17Z",
		stroke: "#363636",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgCardLayout;
